import { useAuth } from "api/hooks/useAuth";
import Default from "layouts/auth/types/Default";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthCard from "widgets/cards/auth";
import SignUpForm, { SignUpFormType } from "widgets/forms/auth/signUp";
import Badge from "widgets/shared/badge";

function SignUpDefault() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [isExpired, setIsExpired] = useState(false);
  // // Extract the filter parameter
  const code = searchParams.get("code");

  // Function for signing up user
  const doSignUp = (formData: SignUpFormType) => {
    if (code) {
      formData.registrationCode = code;
    }
    auth.signUp(formData);
  };

  return (
    <Default
      maincard={
        <div className="mt-6 md:mt-0">
          {isExpired && (
            <div className="mb-4">
              <Badge
                label={t("notification.registration.code.expired")}
                color="red"
              />
            </div>
          )}
          <AuthCard
            title={t("auth.sign_up.title")}
            description={t("auth.sign_up.description")}
            footer={t("auth.sign_up.footer")}
            link={t("auth.sign_up.footer.link")}
            onClick={() => navigate("/auth/sign-in/default")}
          >
            <SignUpForm
              disabled={isExpired}
              submit={(data) => {
                doSignUp(data);
              }}
            />
          </AuthCard>
        </div>
      }
    />
  );
}

export default SignUpDefault;
